import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterCasinoReport from 'views/reports/casinoReport2/filterCasinoReport2'; // Importing filter component for casino report
import TableCasinoReport from 'views/reports/casinoReport2/tableCasinoReport2'; // Importing table component for casino report
import DetailsCasinoReport from 'views/reports/casinoReport2/detailsCasinoReport'; // Importing details component for casino report
import RecordCasinoReport from 'views/reports/casinoReport2/recordCasinoReport'; // Importing record component for casino report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Right section configuration containing records and details
        const right = {
            type: 'wide',
            rows: [RecordCasinoReport, DetailsCasinoReport],
        };

        // Alternative right section configuration for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordCasinoReport, DetailsCasinoReport],
        };

        // Toolbar configuration for pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar1',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on selection change
                            $$('datatable').getPager().config.size = this.getValue() * 1;
                            $$('datatable').refresh();
                            $$('datatable').scrollTo(100, 0);
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export1',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export selection
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            var table = $$('datatable');
                            var size = $$('datatable').getPager().config.size;
                            var page = $$('datatable').getPage();
                            var first = size * page;
                            var last = first + size - 1;
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [{ value: value, first: first, last: last }]);
                            }
                        },
                    },
                },
            ],
        };

        // Second toolbar configuration for export options
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {},
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export selection
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            if (value == 1) {
                                var table = $$('datatable2');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Casino', // Filename for exported Excel
                                    ignore: { detailTittle: true, Type: true }, // Ignore specific fields
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    webix.toPDF($$('datatable2'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Casino', // Filename for exported PDF
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Type: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left section configuration containing filters and tables
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Reporte de Casino') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterCasinoReport, // Filter component
                TableCasinoReport, // Table component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };

        // Advanced details section configuration
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details section
            ],
        };

        // Responsive advanced details section configuration
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    // Adjust scroll position when expanded
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    $$('a5').scrollTo(100, 0);
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer between sections
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for smaller screens
                            : avanc, // Use avanc for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the Casino Report View.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Hide search button on larger screens
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide();
            }
            // Adjust layout for smaller screens
            if (screen.width < 500 || screen.height < 500) {
                $$('res').hide();
                var childs = $$('toolbar1').getChildViews();
                $$('toolbar1').removeView(childs[2]); // Remove export option from toolbar
                $$('pagerA').define('group', 1); // Group pager for smaller screens
            }
            // jQuery function to calculate scroll bottom
            $.fn.scrollBottom = function () {
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
